import Layout from "@/components/elements/Layout";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";

export default function FAQ() {
  return (
    <Layout
      title={`Lucidity Insights: Powering MENA’s Tech Ecosystems`}
      description={`Lucidity Insights provides data-driven insights, stories and strategies for unlocking the potential of the MEAPT region's Venture Capital and Startup Ecosystems.`}
      meta_image='https://cdn.lucidityinsights.com/thumbnaildefault.jpg'
    >
      <div className='container py-12 lg:py-24'>
        <div className='lg:flex mx-auto max-w-6xl space-y-6 lg:space-y-0 lg:space-x-24'>
          <h2 className='text-4xl lg:text-5xl font-bold lg:leading-tight tracking-tight text-white'>
            Frequently <br /> Asked Questions
          </h2>
          <div className='lg:flex-1 divide-y divide-white/10 -my-3 lg:-my-5'>
            {Array.from({ length: 10 }).map((_, index) => (
              <Collapsible key={index} className='py-3 lg:py-5'>
                <CollapsibleTrigger asChild>
                  <button
                    type='button'
                    className='flex w-full items-start justify-between text-left text-white'
                  >
                    <span className='text-base lg:text-lg font-semibold'>
                      I cannot delete my startup. Is it intentional?
                    </span>
                    <span className='ml-6 flex h-7 items-center'>
                      <svg
                        className='h-6 w-6'
                        fill='none'
                        viewBox='0 0 24 24'
                        stroke-width='1.5'
                        stroke='currentColor'
                        aria-hidden='true'
                      >
                        <path
                          stroke-linecap='round'
                          stroke-linejoin='round'
                          d='M12 6v12m6-6H6'
                        />
                      </svg>
                      <svg
                        className='hidden h-6 w-6'
                        fill='none'
                        viewBox='0 0 24 24'
                        stroke-width='1.5'
                        stroke='currentColor'
                        aria-hidden='true'
                      >
                        <path
                          stroke-linecap='round'
                          stroke-linejoin='round'
                          d='M18 12H6'
                        />
                      </svg>
                    </span>
                  </button>
                </CollapsibleTrigger>
                <CollapsibleContent asChild>
                  <div className='mt-2 pr-12'>
                    <p className='text-sm lg:text-base leading-relaxed font-light text-white/60'>
                      I don&#039;t know, but the flag is a big plus. Lorem ipsum
                      dolor sit amet consectetur adipisicing elit. Quas
                      cupiditate laboriosam fugiat.
                    </p>
                  </div>
                </CollapsibleContent>
              </Collapsible>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}
